function Filter() {
  return function(phone) {
    if (!phone) {
      return '';
    }

    phone = phone.replace(/[^\d]/g, '');

    return '(' + phone.substring(0, 3) + ')' + ' ' + phone.substring(3, 6) + '-' + phone.substring(6); //eslint-disable-line
  };
}

Filter.$inject = [];

export default Filter;



// WEBPACK FOOTER //
// ./src/filters/phoneNumberFilter.js